/**
 * 青岛一缆电缆有限公司-数据
 */
const icon1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon1.png";
const icon2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon2.png";
const icon3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon3.png";
// 青岛一缆电缆有限公司
const ylgs1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylgs1.png";
const yllb1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/yllb1.png";
const yllb2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/yllb2.png";
const yllb3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/yllb3.png";
const yllb4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/yllb4.png";
//产品信息
const ylcp1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylcp1.png";
const ylcp2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylcp2.png";
const ylcp3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylcp3.png";
const ylcp4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylcp4.png";
const ylcp5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylcp5.png";
const ylcp6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylcp6.png";
const ylcp7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylcp7.png";
const ylcp8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylcp8.png";
const ylcp9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylcp9.png";
const ylcp10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylcp10.png";
const ylbg1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg1.png";
const ylbg2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg2.png";
const ylbg3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg3.png";
const ylbg4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg4.png";
const ylbg5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg5.png";
const ylbg6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg6.png";
const ylbg7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg7.png";
const ylbg8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg8.png";
const ylbg9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg9.png";
const ylbg10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg10.png";
const ylbg11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg11.png";
const ylbg12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg12.png";
const ylbg13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg13.png";
const ylbg14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg14.png";
const ylbg15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg15.png";
const ylbg16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg16.png";
const ylbg17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg17.png";
const ylbg18 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg18.png";
const ylbg19 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg19.png";
const ylbg20 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylbg20.png";
//工程案例
const ylgc1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylgc1.png";
const ylgc2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylgc2.png";
const ylgc3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylgc3.png";
const ylgc4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylgc4.png";
const ylgc5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylgc5.png";
const ylht1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylht1.png";
const ylht2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylht2.png";
const ylht3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylht3.png";
const ylht4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylht4.png";
const ylht5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylht5.png";
const ylht6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylht6.png";
const ylht7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylht7.png";
const ylht8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylht8.png";
const ylht9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylht9.png";

const ylxc1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylxc1.png";
const ylxc2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylxc2.png";
const ylxc3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylxc3.png";
const ylxc4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylxc4.png";
const ylxc5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylxc5.png";
const ylxc6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylxc6.png";
const ylxc7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylxc7.png";
export default {
	homeData: {
		herderBanner: [yllb1, yllb2, yllb3, yllb4],
		//企业logo
		logo: "http://qdyilan.com/static/upload/image/20221116/1668564501366437.png",
		// logo: dx_logo,
		//企业Vr背景
		vRlogo: ylgs1,
		isShowVrModal: false,
		isShowVr: true,
		vRurl: "https://fs.m2.com.cn/home/20240171",
		isVideo: true,
		videoLogo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/mp4/ylfm.png",
		videoUrl: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/mp4/yl.mp4",

		//首页banner
		bannerHeight: "300px",
		banner: [
			"https://cbu01.alicdn.com/img/ibank/O1CN01T3X6TN1vRuP2TW5Sz_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN011pHE411vRuPAvkMuF_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN01GTletP1vRuP4R6kYk_!!2206529366170-0-cib.jpg",
		],
		//企业介绍
		overview: `青岛一缆电缆有限公司始建于2011年，系专业从事电线电缆研发与制造的现代化大型企业。公司建有绝缘电线车间、低压电缆车间、高压电缆车间及电缆附件、铜加工车间等。下设行政事务部、市场营销部、技术研发部、质量管理部、计划财务部、物资供应部、安全生产部等部门，并在全国106个大中城市设有销售服务机构。公司主导产品为：橡套软电缆、护套电缆、控制电缆、电力电缆、架空绝缘电缆、铝绞线及钢芯铝绞线、聚氯乙烯绝缘无护套（软）电线电缆等，并重点开发生产了低烟无卤、低烟低卤、预分支电缆及各种阻燃、耐火、屏蔽.矿物电缆等特种电缆达10000多个规格型号。年生产能力可达10亿元。公司均可按国家或国际标准生产。“青鑫”牌电线电缆被全国三十多个省市、自治区广泛应用于电力、煤炭、交通、建筑、石油、化工、冶金、航空、铁路等各个领域，深受广大用户的信赖与好评。“因专注而专业”多年专注从事电力电缆的研发与制造，生产经营丰富，制造技术先进，检测手段完善，企业管理规范。`,
		//公司官网
		website: "http://qdyilan.com/",
		operatingStatus: "正常在业",
		//经营品类
		categories: `电线电缆、铜材、铝材、低压电器的制造、销售，批发、零售；电工器材、五金交电、电器配件、建材、普通机械设备，货物及技术进出口（国家法律法规禁止经营的项目不得经营，法律法规限制经营的取得许可后方可经营）。（依法须经批准的项目，经相关部门批准后方可开展经营活动）`,
		//公司地址
		companyAddress: "山东省青岛市胶州市平安大道东首马铁路西侧",
		site: "山东省青岛市",
		//经营模式
		mode: "生产型企业",
		//注册资金
		capital: "21800万人民币",
		//成立日期
		establishment: "2011-4-22",
		//经营品牌
		brand: "青鑫电缆",
		//主营产品
		mainProducts: "生产、销售防水材料、保温材料；防水防腐保温工程专业承包壹级；销售化工原料、建材、钢材、五金、汽车配件。",
		//企业名称
		headerTitle: "青岛一缆电缆有限公司",
		moreInfoName: "青岛一缆电缆有限公司",
		//供货区域
		supplyArea: "全国",
		//付款条件
		paymentTerms: `1.现款现结
		2.预付款（可与其他项组合）
		3.货到付款`,
		//工厂地址
		factoryAddress: "山东省青岛市胶州市平安大道东首马铁路西侧",
		//工厂人数
		factoryHeadcount: "82",
		//产能
		capacity: "暂无信息",
		//年产值
		annualOutputValue: "暂无信息",

		// 生产规模
		// 生产基地总数
		// 生产基地总面积
		// 单个基地年产量
		factoryAddress: "省市布局1-2个",
		factoryHeadcount: "53000平方米",
		capacity: "10亿万米",

		//联系负责人
		person: "雷靖 ",
		//联系电话
		contactNumber: "13280835037",
		//资质证书
		qualificationList: [
			{
				name: "安全许可证",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylzz1.png",
			},
			{
				name: "环境管理体系认证证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylzz2.jpg",
			},
			{
				name: "检验检测机构资质认定证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylzz3.jpg",
			},
			{
				name: "营业执照",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylzz4.png",
			},
			{
				name: "职业健康安全管理体系认证证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylzz5.jpg",
			},
			{
				name: "质量管理体系认证证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylzz6.jpg",
			},
			{
				name: "中国国家强制性产品认证证书01",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylzz7.jpg",
			},
			{
				name: "中国国家强制性产品认证证书02",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylzz8.jpg",
			},
			{
				name: "中国国家强制性产品认证证书03",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylzz9.jpg",
			},
		],
		//荣誉证书
		certificateList: [
			{
				name: "青岛质检院CNAS证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylry1.jpg",
			},
			{
				name: "制造业领域AAA级信用企业 (2)",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylry2.jpg",
			},
			{
				name: "中国节能环保产品",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylry3.jpg",
			},
			{
				name: "中国十佳诚信企业",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylry4.jpg",
			},
			{
				name: "中国著名品牌",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylry5.jpg",
			},
		],
		//合作伙伴
		cooperativeList: [
			{
				name: "中国石油天然气集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylhb1.png",
				desc: "",
			},
			{
				name: "中国石化集团公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylhb2.png",
				desc: "",
			},
			{
				name: "中国联合网络通信集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylhb3.png",
				desc: "",
			},
			{
				name: "中国移动通信集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylhb4.png",
				desc: "",
			},
			{
				name: "山东高速集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylhb5.png",
				desc: "",
			},
			{
				name: "中国华能集团公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylhb6.png",
				desc: "",
			},
			{
				name: "中国建筑股份有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylhb7.png",
				desc: "",
			},
			{
				name: "中国国家铁路集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylhb8.png",
				desc: "",
			},
			{
				name: "海尔集团公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylhb9.png",
				desc: "",
			},
			{
				name: "浦林成山山东轮胎有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylhb10.png",
				desc: "",
			},
			{
				name: "华润集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylhb11.png",
				desc: "",
			},
			{
				name: "中粮集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylhb12.png",
				desc: "",
			},
			{
				name: "海信集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qdyl/ylhb13.png",
				desc: "",
			},
		],
		//投标数据
		biddingList: [
			{
				name: "中标次数",
				numText: 0,
				num: 0,
				path: icon1,
				color: "#FFBC51",
			},
			{
				name: "履约次数",
				numText: 0,
				num: 0,
				path: icon2,
				color: "#F184A0",
			},
			{
				name: "履约金额",
				numText: "--",
				num: "--",
				path: icon3,
				color: "#AAABC1",
			},
		],
		//为您推荐其他家类似供应商列表
		recommendList: [],
	},
	listData: {
		productList: [
			{ name: "聚氯乙烯绝缘聚氯乙烯护套控制电缆", img: ylcp1 },
			{ name: "电缆", img: ylcp2 },
			{ name: "电缆", img: ylcp3 },
			{ name: "交联聚乙烯绝缘聚烯烃护套无卤低烟阻燃C类控制电缆", img: ylcp4 },
			{ name: "电力电缆", img: ylcp5 },
			{ name: "电力电缆", img: ylcp6 },
			{ name: "低烟无卤聚烯烃A级阻燃耐火电力电缆 2020310842", img: ylcp7 },
			{ name: "电线", img: ylcp8 },
			{ name: "电线", img: ylcp9 },
			{ name: "电线", img: ylcp10 },
		],
		navList: [
			{
				name: "电缆",
				isShow: false,
				id: 1,
				children: [
					"聚氯乙烯绝缘聚氯乙烯护套控制电缆",
					"电缆",
					"电缆",
					"交联聚乙烯绝缘聚烯烃护套无卤低烟阻燃C类控制电缆",
					"电力电缆",
					"电力电缆",
					"低烟无卤聚烯烃A级阻燃耐火电力电缆 2020310842",
				],
			},
			{
				name: "电线",
				isShow: false,
				id: 2,
				children: ["电线", "电线", "电线"],
			},
		],
	},
	productDetailsData: {
		聚氯乙烯绝缘聚氯乙烯护套控制电缆: {
			name: "聚氯乙烯绝缘聚氯乙烯护套控制电缆",
			img: ylcp1,
			modelNumber: [
				{
					title: "暂无",
					img: ylcp1,
				},
			],
			price: "--",
			detailImgs: [ylcp1],
			modelNumberText: "KVV 2×4 （2019）GJYDX-JC0014",
			brand: "青岛一缆",
			describe: `--`,
			report: [ylbg1, ylbg2],
		},

		电缆: {
			name: "电缆",
			img: ylcp2,
			modelNumber: [
				{
					title: "暂无",
					img: ylcp2,
				},
			],
			price: "--",
			detailImgs: [ylcp2],
			modelNumberText: "WDZN-YJY  5X10202121000981",
			brand: "青岛一缆",
			describe: `--`,
			report: [ylbg3, ylbg4],
		},

		电缆: {
			name: "电缆",
			img: ylcp3,
			modelNumber: [
				{
					title: "暂无",
					img: ylcp3,
				},
			],
			price: "--",
			detailImgs: [ylcp3],
			modelNumberText: "VLV22 3×120＋1×70 202021000499",
			brand: "青岛一缆",
			describe: `--`,
			report: [ylbg5, ylbg6],
		},

		交联聚乙烯绝缘聚烯烃护套无卤低烟阻燃C类控制电缆: {
			name: "交联聚乙烯绝缘聚烯烃护套无卤低烟阻燃C类控制电缆",
			img: ylcp4,
			modelNumber: [
				{
					title: "暂无",
					img: ylcp4,
				},
			],
			price: "--",
			detailImgs: [ylcp4],
			modelNumberText: "WDZC-KYJY  37×1.5 DQ19062",
			brand: "青岛一缆",
			describe: `--`,
			report: [ylbg7, ylbg8],
		},

		电力电缆: {
			name: "电力电缆",
			img: ylcp5,
			modelNumber: [
				{
					title: "暂无",
					img: ylcp5,
				},
			],
			price: "--",
			detailImgs: [ylcp5],
			modelNumberText: "ZC-YJV220 3×95+1×50QTC-921001417",
			brand: "青岛一缆",
			describe: `--`,
			report: [ylbg9, ylbg10],
		},

		电力电缆: {
			name: "电力电缆",
			img: ylcp6,
			modelNumber: [
				{
					title: "暂无",
					img: ylcp6,
				},
			],
			price: "--",
			detailImgs: [ylcp6],
			modelNumberText: "NH-YJV4×35+×16QTC-921000535",
			brand: "青岛一缆",
			describe: `--`,
			report: [ylbg11, ylbg12],
		},

		"低烟无卤聚烯烃A级阻燃耐火电力电缆 2020310842": {
			name: "低烟无卤聚烯烃A级阻燃耐火电力电缆 2020310842",
			img: ylcp7,
			modelNumber: [
				{
					title: "暂无",
					img: ylcp7,
				},
			],
			price: "--",
			detailImgs: [ylcp7],
			modelNumberText: "WDZAN-II-YJY1×300",
			brand: "青岛一缆",
			describe: `--`,
			report: [ylbg13, ylbg14],
		},

		电线: {
			name: "电线",
			img: ylcp8,
			modelNumber: [
				{
					title: "暂无",
					img: ylcp8,
				},
			],
			price: "--",
			detailImgs: [ylcp8],
			modelNumberText: "NH-KVV 7X1.5 202121001563",
			brand: "青岛一缆",
			describe: `--`,
			report: [ylbg15, ylbg16],
		},

		电线: {
			name: "电线",
			img: ylcp9,
			modelNumber: [
				{
					title: "暂无",
					img: ylcp9,
				},
			],
			price: "--",
			detailImgs: [ylcp9],
			modelNumberText: "ZC-KVV4X1.5 2021001560",
			brand: "青岛一缆",
			describe: `--`,
			report: [ylbg17, ylbg18],
		},

		电线: {
			name: "电线",
			img: ylcp9,
			modelNumber: [
				{
					title: "暂无",
					img: ylcp9,
				},
			],
			price: "--",
			detailImgs: [ylcp9],
			modelNumberText: "ZN-KVV 7X1.5 202121001617",
			brand: "青岛一缆",
			describe: `--`,
			report: [ylbg19, ylbg20],
		},
	},
	contactListData: {
		list: [
			{
				name: "雷靖",
				position: "销售经理(全国)",
				id: "1",
				phoneNum: "13280835037",
				telephone: "--",
				color: "#007DFF ",
				email: "2210791183@qq.com",
			},
			{
				name: "尹彤辉",
				position: "销售经理(全国)",
				id: "2",
				phoneNum: "15563968339",
				telephone: "--",
				color: "#23B095 ",
				email: "1207557449@qq.com",
			},
		],
	},
	caseData: {
		list: [
			{
				name: "济南工程2020-MM20018",
				id: 1,
				price: "63万元",
				time: "2020",
				site: "山东省济南市",
				type: "居民楼",
				unit: "山东济铁工程建设集团有限公司",
				desc: "济南工程2020-MM20018 位于山东省济南市由山东济铁工程建设集团有限公司建设的工程项目",
				//现场图片
				imgList: [
					{ title: "", path: ylxc1 },
					{ title: "", path: ylxc2 },
				],
				//轮播图
				proImgList: [{ title: "", path: ylgc1 }],
				// 合作证明图
				contractList: [
					{ title: "", path: ylht1 },
					{ title: "", path: ylht2 },
				],
				product: "电线电缆",
			},

			{
				name: "威海热电集团办公宿舍楼",
				id: 2,
				price: "50万元",
				time: "2020",
				site: "山东省威海市",
				type: "宿舍楼",
				unit: "威海热电集团有限公司",
				desc: "威海热电集团办公宿舍楼建设项目位于山东省威海市主要用于威海热电集团员工的办公和住宿",
				//现场图片
				imgList: [
					{ title: "", path: ylxc3 },
					{ title: "", path: ylxc4 },
				],
				//轮播图
				proImgList: [{ title: "", path: ylgc2 }],
				// 合作证明图
				contractList: [{ title: "", path: ylht3 }],
				product: "电线电缆",
			},

			{
				name: "兴正嘉园一期",
				id: 3,
				price: "728万",
				time: "2020",
				site: "福建省",
				type: "居民楼",
				unit: "福建省浦口建筑工程有限公司",
				desc: "兴正嘉园一期主要油福建省浦口建筑工程有限公司承建",
				//现场图片
				imgList: [
					{ title: "", path: ylxc5 },
					{ title: "", path: ylxc6 },
				],
				//轮播图
				proImgList: [{ title: "", path: ylgc3 }],
				// 合作证明图
				contractList: [
					{ title: "", path: ylht4 },
					{ title: "", path: ylht5 },
				],
				product: "电线电缆",
			},

			{
				name: "中国石油大学华东古镇口教师宿舍",
				id: 4,
				price: "35万",
				time: "2021",
				site: "山东省青岛市",
				type: "宿舍楼",
				unit: "福建省浦口建筑工程有限公司",
				desc:
					"中国石油大学华东古镇口教师宿舍由中建八局第一建设有限公司承建主要位于山东省青岛市，该项目用于中国石油大学华东的教师宿舍",
				//现场图片
				imgList: [{ title: "", path: ylxc7 }],
				//轮播图
				proImgList: [{ title: "", path: ylgc4 }],
				// 合作证明图
				contractList: [
					{ title: "", path: ylht6 },
					{ title: "", path: ylht7 },
				],
				product: "电线电缆",
			},

			{
				name: "温州液化天然气(LNG)接收站",
				id: 4,
				price: "90万",
				time: "2022",
				site: "浙江省温州市",
				type: "天然气接收站",
				unit: "中国石化天然气公司",
				desc:
					"中国石油大学华东古镇口教师宿舍由中建八局第一建设有限公司承建主要位于山东省青岛市，该项目用于中国石油大学华东的教师宿舍",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: ylgc5 }],
				// 合作证明图
				contractList: [
					{ title: "", path: ylht8 },
					{ title: "", path: ylht9 },
				],
				product: "电线电缆",
			},
		],
	},
	evaluationData: {
		//企业诚信
		goodFaithList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "企业失信",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "法律诉讼",
				isShow: true,
				number: 1,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "行政处罚",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "严重违纪",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "经营异常",
				isShow: false,
				number: 0,
			},
		],
		//实力徽章
		badgeList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${9}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${9}.png`,
				title: "CNAS",
				subtitle: "实验室认证",
				isShow: true,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/suibian.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/suibian.png`,
				title: "中国",
				subtitle: "节能环保产品",
				isShow: true,
			},
		],
	},
	successfulBidderData: {
		info: [
			{
				name1: "2023年度山东泛海光能科技有限公司光伏电站并网箱/柜、电线电缆材料采购",
				name2: "2023年度山东泛海光能科技有限公司光伏电站并网箱/柜、电线电缆材料采购(标包002)",
				name3: "物资采购",
				date: "2023-3-20",
			},
			{
				name1: "华东分公司山东联盟化工40.60工程清洁生产技术升级改造项目",
				name2: "中化二建集团有限公司-华东分公司-山东联盟化工-电缆",
				name3: "物资采购",
				date: "2022-11-4",
			},
			{
				name1: "中铁建工集团有限公司高实合苑项目电线电缆招标采购",
				name2: "中铁建工集团有限公司高实合苑项目电线电缆招标采购",
				name3: "物资采购",
				date: "2021-8-21",
			},
			{
				name1: "山东济铁工程集团有限公司济南工程分公司工程用电力电缆网上竞价",
				name2: "工程用电力电缆网上竞价",
				name3: "物资采购",
				date: "2020-6-17",
			},
			{
				name1: "山东济铁工程建设集团有限公司济南水电工程分公司工程用低压电缆终端头等网上竞价",
				name2: "第001包:低压电缆终端头等",
				name3: "物资采购",
				date: "2020-6-12",
			},
			{
				name1: "昌邑市路灯所电缆采购项目",
				name2: "昌邑市路灯所电缆采购项目",
				name3: "物资采购",
				date: "2020-6-1",
			},
			{
				name1: "威海热电集团有限公司热源一厂低压电缆、控制电缆、计算机电缆采购项目",
				name2: "威海热电集团有限公司热源一厂低压电缆、控制电缆、计算机电缆采购项目",
				name3: "物资采购",
				date: "2020-4-14",
			},
			{
				name1: "莱芜电厂电缆采购",
				name2: "莱芜电厂电缆采购",
				name3: "物资采购",
				date: "2020-4-1",
			},
			{
				name1: "泰安京沪高铁南片区堰岭小区规划二路三街、金陡山规划路和平社区规划路西黄东路电缆采购",
				name2: "标段(包)[001]泰安京沪高铁南片区堰岭小区规划二路三街、金陡山规划路和平社区规划路西黄东路电缆采购项目",
				name3: "物资采购",
				date: "2019-11-9",
			},
		],
	},
	lawData: {
		info: [
			{
				caseName: "青岛青缆科技有限责任公司、青岛一缆电缆有限公司等不正当竞争纠纷首次执行执行裁定书",
				// 案号
				reference: "（2023）鲁02执72号",
				// 案由
				cause: "不正当竞争纠纷",
				//身份
				identity: "被执行人",
				//类型
				caseType: "执行案件",

				date: "2023-03-02",
			},
		],
	},
	tipData: {
		info: [
			{
				title: "陕建云采会员",
			},
			{
				title: "成立10年以上",
			},
		],
	},
};
